// Real payment configuration for Northwind deposits

export const cryptoMethods = [
  {
    id: "usdt",
    label: "USDT (TRC20)",
    short: "USDT",
    network: "Tron (TRC20)",
    address: "TBcgmPU6Qr496d5j34RRZBmfcZN431hVhR",
    color: "#26a17b",
    note: "Send only USDT via TRC20 network. Other networks will result in loss of funds.",
  },
  {
    id: "trx",
    label: "TRX (Tron)",
    short: "TRX",
    network: "Tron",
    address: "TBcgmPU6Qr496d5j34RRZBmfcZN431hVhR",
    color: "#ec0928",
    note: "Send only TRX on the Tron network.",
  },
  {
    id: "btc",
    label: "Bitcoin (BTC)",
    short: "BTC",
    network: "Bitcoin",
    address: "bc1q69y586yhylrntlkv2ttngmk4vdxsv4dum0y8q3",
    color: "#f7931a",
    note: "Send only BTC to this address. Confirmations may take 10–30 minutes.",
  },
];

export const bankDetails = {
  beneficiary: "Davdags ltd",
  accountNumber: "6524826701",
  bank: "Moniepoint",
  currency: "NGN",
  telegram: "https://t.me/northwindmarkets",
  telegramHandle: "@northwindmarkets",
};
